import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAudienceMembershipDeltas as GetAudienceMembershipDeltasQuery,
    GetAudienceMembershipDeltasVariables as GetAudienceMembershipDeltasQueryVariables,
    GetAudienceMembershipDeltas_audience_membershipStats_totalCountDelta as TotalCountDelta,
} from 'nutshell-graphql-types';

import GET_AUDIENCE_MEMBERSHIP_DELTAS from '../queries/get-audience-membership-deltas.graphql';

export const useGetAudienceMembershipDeltas = (
    audienceId: string
): {
    totalCountDelta: TotalCountDelta | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {loading, data, error} = useQuery<
        GetAudienceMembershipDeltasQuery,
        GetAudienceMembershipDeltasQueryVariables
    >(GET_AUDIENCE_MEMBERSHIP_DELTAS, {
        variables: {audienceId},
        notifyOnNetworkStatusChange: true,
    });

    const totalCountDelta = data?.audience?.membershipStats?.totalCountDelta;

    return {
        totalCountDelta,
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
